document.addEventListener('readystatechange', function() {
  if(document.readyState == "complete") {
    const reviewsLinks = document.querySelectorAll('.product__info-container .standalone-bottomline')
    Array.from(reviewsLinks).forEach(function(reviewsLink) {
      reviewsLink.addEventListener('click', function() {
        const mainWidget = document.querySelector('.main-widget')
        if(mainWidget) {
          setTimeout(() => {
            mainWidget.scrollIntoView({
              behavior: 'smooth',
            });
          }, 10);
        }
      })
    })
  }
})
